module.exports = __webpack_public_path__ + "static/media/varys.421b28b0.jpg";